import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const AdmissionEligibility = () => {
  useEffect(() => {
    document.title = "Admission Eligibility -  Mary Matha Cmi  Academy";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Admission Eligibility </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Admission Eligibility </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="mainlist">
                <li>
                  {" "}
                  Admission for all classes will depend upon the availability of
                  seats.{" "}
                </li>
                <li>
                  {" "}
                  Students have to appear for the aptitude test and language
                  assessment based on which the enlistment is proceeded.{" "}
                </li>
                <li>
                  {" "}
                  <b>For grades Pre-KG to VIII </b> Languages, Maths, Science,
                  Social Science, Computer Science and General Knowledge.{" "}
                </li>
                <li> Application forms are available in the school office. </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdmissionEligibility;
